import React from 'react';
import { HelpCircle } from 'lucide-react';
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from './hover-card';

/**
 * Componente de Ajuda Contextual
 * Exibe um ícone "?" que ao passar o mouse mostra um card com explicação
 */
export const HelpTooltip = ({ 
  title, 
  description, 
  connections = [],
  className = "",
  iconSize = 16,
  side = "top"
}) => {
  return (
    <HoverCard openDelay={150} closeDelay={100}>
      <HoverCardTrigger asChild>
        <button 
          type="button"
          onClick={(e) => { e.stopPropagation(); e.preventDefault(); }}
          className={`inline-flex items-center justify-center text-blue-400 hover:text-blue-600 transition-colors focus:outline-none rounded-full ${className}`}
          aria-label="Ajuda"
        >
          <HelpCircle size={iconSize} />
        </button>
      </HoverCardTrigger>
      <HoverCardContent 
        side={side} 
        className="w-80 p-0 shadow-lg"
        sideOffset={5}
      >
        <div className="bg-white rounded-lg overflow-hidden">
          <div className="bg-blue-50 px-4 py-2 border-b border-blue-100">
            <h4 className="font-semibold text-blue-900 text-sm">{title}</h4>
          </div>
          <div className="px-4 py-3">
            <p className="text-sm text-gray-700 leading-relaxed">{description}</p>
            {connections && connections.length > 0 && (
              <div className="mt-3 pt-3 border-t border-gray-100">
                <p className="text-xs text-gray-500 flex items-center gap-1">
                  <span className="font-medium">Conecta com:</span>
                  <span className="text-blue-600">{connections.join(', ')}</span>
                </p>
              </div>
            )}
          </div>
        </div>
      </HoverCardContent>
    </HoverCard>
  );
};

/**
 * Wrapper para títulos com ajuda
 * Facilita adicionar ajuda ao lado de títulos de seção
 */
export const TitleWithHelp = ({ 
  children, 
  title, 
  description, 
  connections = [],
  className = "",
  helpClassName = ""
}) => {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {children}
      <HelpTooltip 
        title={title} 
        description={description} 
        connections={connections}
        className={helpClassName}
      />
    </div>
  );
};

/**
 * Wrapper para labels de formulário com ajuda
 */
export const LabelWithHelp = ({ 
  children, 
  title, 
  description, 
  connections = [],
  className = "",
  htmlFor = ""
}) => {
  return (
    <div className={`flex items-center gap-1.5 ${className}`}>
      <label htmlFor={htmlFor} className="text-sm font-medium text-gray-700">
        {children}
      </label>
      <HelpTooltip 
        title={title} 
        description={description} 
        connections={connections}
        iconSize={14}
        side="right"
      />
    </div>
  );
};

export default HelpTooltip;
